<template>
  <van-popup position="bottom" v-model="isShow">
    <div class="container f28">
      <div class="title">建议修复服务项</div>
      <ul>
        <li class="actived">名品包深度翻新护理（小）| ¥388</li>
        <li>五金配件换新（小）| ¥388</li>
        <li>五金配件换新（小）| ¥388</li>
      </ul>
      <div class="close" @click="hide"></div>
      <div class="bottom">
        <button class="submit btn-black-round" @click="hide">确定</button>
        <span>已选 1 种服务</span>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import { Popup } from 'vant'
  export default {
    name: 'selectService',
    components: {
      'van-popup': Popup
    },
    data () {
      return {
        isShow: false
      }
    },
    methods: {
      show () {
        this.isShow = true
      },
      hide () {
        this.isShow = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .van-popup--bottom{
    width: 101%;
  }
  .container{
    min-height: 548px;
    padding: 30px;
    position: relative;
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    ul{
      display: flex;
      flex-wrap: wrap;
    }
    li{
      padding: 0 30px;
      height: 56px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 34px;
      margin-bottom: 50px;
      background: rgba(236,236,236,1);
      border: 1px solid rgba(236,236,236,1);
      &.actived{
        border: 1px solid #7ADFDF;
        background: rgba(121,207,207,0.1);
      }
    }
    .bottom{
      position: absolute;
      width: 690px;
      bottom: 30px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .submit{
        margin-left: 20px;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }
</style>
